import React, { useEffect } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { showToast } from '../common/Toast';

const PaymentCancel = () => {
  const navigate = useNavigate();

  useEffect(() => {
    // Nettoyer la session
    sessionStorage.removeItem('aeii_pending_payment');
    showToast('Paiement annulé', 'error');
  }, []);

  return (
    <section className="section">
      <div className="container text-center" style={{ maxWidth: '500px', margin: '0 auto' }}>
        <div style={{ 
          padding: '60px 30px',
          background: '#fff5f5',
          borderRadius: '16px',
          border: '1px solid #fed7d7'
        }}>
          <i className="fa-solid fa-ban" style={{ fontSize: '4rem', color: '#fc8181' }}></i>
          <h2 style={{ marginTop: '20px', color: '#742a2a' }}>Paiement annulé</h2>
          <p style={{ color: '#9b2c2c' }}>
            Vous avez annulé le processus de paiement. Aucun montant n'a été débité.
          </p>
          <div style={{ display: 'flex', gap: '12px', justifyContent: 'center', flexWrap: 'wrap', marginTop: '20px' }}>
            <Link to="/abonnements" className="btn btn-dark">
              <i className="fa-solid fa-arrow-left"></i> Retour aux abonnements
            </Link>
            <Link to="/publications" className="btn btn-ghost">
              <i className="fa-solid fa-book"></i> Voir les publications
            </Link>
          </div>
        </div>
      </div>
    </section>
  );
};

export default PaymentCancel;